import Vue from "vue";
import App from "./App.vue";
import VCalendar from 'v-calendar';

import "leaflet/dist/leaflet.css";

import store from "@/store";

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.config.productionTip = false;

Vue.filter("truncate", (texto, limite) => {
  if (texto.length > limite) {
    texto = texto.substring(0, limite - 3) + "...";
  }
  return texto;
});

Vue.filter("humanTime", (tiempo) => {
  let [horas, minutos] = [parseInt(tiempo / 60), tiempo % 60];
  if (minutos < 10) minutos = "0" + minutos.toString();
  return `${horas}:${minutos}`;
});

Vue.filter("humanDistance", (distancia) => {
  const [kilometros, metros] = [distancia / 1000, distancia % 1000];
  if (kilometros > 1) return `${kilometros.toFixed(1)} Km`;
  else return `${metros} m`;
});

Vue.filter("fechaEs", (fecha) => {
  return fecha
    .split("-")
    .reverse()
    .join("/");
});

new Vue({
  el: "reserva-circuito",
  store,
  components: {
    visor: App,
  },
  //template:'<div><local :i18n="i18n"></local></div>',
  data: {
    i18n: "es",
    refugios: []
  },
  beforeMount() {
    this.i18n = this.$el.attributes["idioma"].value || "es";
    this.refugios = this.$el.attributes["refugios"].value.split(',') || [];
  },
  render(h) {
    return h(App, { props: { i18n: this.i18n, refugios: this.refugios } });
  },
});
